module.exports = __webpack_public_path__ + "static/media/java.1faf0791.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/java.png
// module id = 97
// module chunks = 0